import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState } from "react";
function Article7() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });

  const { ref: secondContainer, inView: secondInView } = useInView({
    threshold: 0
  });


  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';
      var img2 = document.getElementById("img2");
      img2.className = '';

      return "";
    }

    else if (secondInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = 'active';

      return "";
    }
  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article8');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article6');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 700); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article7-left-img1.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">
          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article7-left-img1.jpg")} alt="" />
          </motion.div>

          <motion.div
            variants={textAnimate}
            className="hamburger-menu mb-4 mb-sm-5">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
          <div className="" ref={firstContainer}>
            <h1 className="fs-xl f-lora mb-2">WILD KABN KITCHEN </h1>
            <h2 className="f-lora-i mb-4">from the embers</h2>
            <h6 className="f-lora-i lh-base" variants={textAnimate}>Alfresco dining takes a decadent twist on the Ardkinglas Estate, where Wild Kabn Kitchen puts organic vegetables to the flame as it seeks to explore the deep connection between food, fire and nature in the wilds of Loch Fyne.</h6>

            <div className="row mb-4 mb-sm-5">
              <div className="col-sm-6">
                <p className="mb-4">As pink dusk fades to night over the gently lapping waters of north-western Loch Fyne, swollen pinpricks of golden light twinkle from silver lanterns in the greenhouse on the Ardkinglas Estate. Mirrors throw the smudged gold around, its glow landing in the furrows and grooves of the rustic structure and smudging definition from the grapevines that dangle overhead. Handmade plates are lined up with shiny wine glasses along a table set for eight, and the air is drenched with the scent of char; rich and mellow. Wild Kabn Kitchen is ready for the evening’s guests.</p>
                <p className="mb-4">“The Wild Kabn Kitchen concept revolves around a culinary journey that explores the connection between food, fire and nature,” explains outdoor chef William Hamer, who founded the wilderness-based experiences in 2023. A typical evening starts on the loch shore, in front of Ardking Estate House, before you maze along secret pathways in the estate’s 18th-century gardens, a honeycomb of wildflowers and stone walls, the lot overlooked by the soaring conifers of the Ardkinglas woodland that create a smudged charcoal belt across the backdrop of mountains. And then it is time to dine.</p>
                <p className="mb-4">Almost the entire meal, usually five or six courses, is cooked over an open fire. William discovered firebased outdoor cooking while living on North Uist. “On my days off from working at Langass Lodge, I would throw some ingredients in my bag and venture to the beach and build a fire,” he remembers. “But fire has always been a fascination of mine. It connects with something deep inside us – there’s a primal instinct to gaze into it and explore its wild ways. You will never have full control of it – you must work with the fire and try to understand its behaviour.” </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-4">What’s surprising is the variety of vegetables that feature in the Wild Kabn Kitchen suppers – a rainbow of produce from the estate’s garden: depending on the season, there might be wild strawberries, Jerusalem artichokes, tomatoes or courgettes. “Vegetables have a magnificent reaction to fire,” says William. He explains that cauliflower works particularly well: “I submerge it in the fire until it’s almost falling apart and a beautiful charred crust has formed around the outside, then I serve it with Scottish salted yoghurt to complement the char.”</p>
                <p className="mb-4">William trained as a chef in a countryside pub in the south of England. He went on to travel the world, “picking up kitchen jobs wherever I could,” and secured a position as stagier at the two-Michelin-starred Hisa Franko in Slovenia, cooking alongside some of the world’s top chefs. He later set up his own pop-up restaurant, The Wilder Kitchen, in the Outer Hebrides. This year he returned south, continuing with his popup business, but also arranging to meet the owners of Ardkinglas (which is also home to Kabn Company’s two Japandi-style luxury cabins). “Six months later, we opened the Wild Kabn Kitchen,” he smiles.</p>
                <p className="mb-4">In a nutshell, William describes the Wild Kabn Kitchen experience as “unique and romantic”: the taste of charred vegetables, the glow of the flames, the cool air prickling your skin.   “Outdoor dining creates a connection with the land you are standing on,” says William. “Everything is stripped back. You feel the warmth of the food, and you gain an insight into how our ancestors ate many hundreds of years ago.”</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      </motion.div>
      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>
    </motion.div>

  );
}

export default Article7;
